var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m385.068 204.272h-189.679v-64.175c0-33.336 27.275-60.61 60.61-60.61 27.382 0 50.674 18.402 58.121 43.45 5.717 19.23 31.046 23.181 42.738 7.516 4.679-6.269 6.001-13.682 3.777-21.181-13.384-45.118-55.326-78.272-104.636-78.272-60.004 0-109.098 49.094-109.098 109.098v64.174h-19.971c-22.027 0-40.049 18.022-40.049 40.049v196.63c0 22.027 18.022 40.049 40.049 40.049h258.138c22.027 0 40.049-18.022 40.049-40.049v-196.63c0-22.027-18.022-40.049-40.049-40.049zm-114.068 138.543v50.728c0 8.284-6.716 15-15 15s-15-6.716-15-15v-50.728c-11.678-5.599-19.742-17.53-19.742-31.345 0-19.187 15.554-34.742 34.742-34.742s34.742 15.555 34.742 34.742c0 13.816-8.064 25.747-19.742 31.345z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.8ecf24a3e3b708047dd6d59bc58cfef2.svg";
export { ForwardRef as ReactComponent };